export default __webpack_public_path__ + "static/header-iconic-link-developers-icon2.url-1c04aeccb263d3b8fa8dd87aa8c27405.svg";